var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlertWpc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3232 2.12722C11.0684 0.89086 12.9316 0.890861 13.6768 2.12722L23.7377 18.8181C24.483 20.0545 23.5514 21.6 22.0609 21.6H1.93911C0.448604 21.6 -0.482958 20.0545 0.262293 18.8181L10.3232 2.12722Z",
    fill: "#FF6035"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 14.4C11.7613 14.4 11.5324 14.2974 11.3636 14.1148C11.1948 13.9321 11.1 13.6845 11.1 13.4262L11.1 6.97368C11.1 6.71543 11.1948 6.46776 11.3636 6.28515C11.5324 6.10254 11.7613 5.99995 12 5.99995C12.2387 5.99995 12.4676 6.10254 12.6364 6.28515C12.8052 6.46776 12.9 6.71543 12.9 6.97368L12.9 13.4262C12.9 13.6845 12.8052 13.9321 12.6364 14.1148C12.4676 14.2974 12.2387 14.4 12 14.4Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 16.2C11.3372 16.2 10.8 16.7372 10.8 17.4C10.8 18.0627 11.3372 18.6 12 18.6C12.6627 18.6 13.2 18.0627 13.2 17.4C13.2 16.7372 12.6627 16.2 12 16.2Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertWpc);
export default __webpack_public_path__ + "static/media/alertWPC.5fb5d9b04fcd11e6c00b6fe3262c66b1.svg";
export { ForwardRef as ReactComponent };